import React from 'react';
import { Typography } from '@mui/material';

type SunTimeProps = {
  label: string;
  time: string;
};

export const SunTime: React.FC<SunTimeProps> = ({ label, time }) => (
  <Typography variant="body2" color="var(--color-type-primary)">
    {label}: {time}
  </Typography>
);
